import { Component, OnInit, Input } from '@angular/core';
import { KeyValues5, LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-selected-business-title',
  templateUrl: './selected-business-title.component.html',
  styleUrls: ['./selected-business-title.component.scss']
})
export class SelectedBusinessTitleComponent implements OnInit {
  @Input() businessId: string; item: KeyValues5;
  constructor(public localService: LocalService) { }

  ngOnInit(): void {
    this.setBusiness();
  }

  setBusiness() {
    if (this.businessId)
      this.item = this.localService.loggedMember.businesses.find(x => x.key == this.businessId && x.v5 == 'BU');
  }
}
